import React from "react";
import "./Inquiry_Form_Modal.css";
import { Modal } from "react-bootstrap";
import Form_component from "../form_component/Form_Component";

function Inquiry_Form_Modal(props) {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Inquiry_Form_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <p className="title_text">We Are Coming Soon</p>
            <p className="subtile_text">Please fill in the required details.</p>            
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form_component />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Inquiry_Form_Modal;
